// extracted by mini-css-extract-plugin
export default {"container":"PasswordResetPage_container__vS08F","title":"PasswordResetPage_title__Iyfl+"};